<template>
    <div
        v-if="value != 0"
        class="bo-point"
    >
        <i class="icon-bpoint"></i>
        +{{ roundToDecimal(value) }} {{generalTranslations.points ?? 'PTS'}}
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        decimal: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            generalTranslations: window.bo?.generalTranslations ?? {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
        };
    },
    methods: {
        roundToDecimal(number) {
            if (typeof number == "string") {
                return parseFloat(number.toFixed(this.decimal));
            } else {
                return number.toFixed(this.decimal);
            }
        },
    },
};
</script>
